import { gql } from '@apollo/client';

const INSTRUCTORS_QUERY = gql`
    query instructors( $page: Int, $limit: Int, $orderBy: String, $orderDir: String ) {
        instructors( page: $page, limit: $limit, orderBy: $orderBy, orderDir: $orderDir ) {
            edges {
                cursor
                node {
                    id
                    companyId
                    name
                    title
                    description
                    emailAddress
                    createdAt
                    updatedAt
                }
            }
            pageInfo {
                page
                limit
                orderBy
                orderDir
                pageCount
                totalCount
                totalPages
            }
        }
    }
`;

export default INSTRUCTORS_QUERY;
